export const experienceData = [
  {
    date: "May 2026 - July 2026",
    title: "Advanced Application Engineering Intern @Accenture",
    organization: "Accenture", // dont matter in UI
    description: `
    AEH Intern.
    `,
    logo: "/images/accenture-logo.png",
    logoClr: "bg-white",
    badges: [],
  },
  {
    date: "March 2026 - May 2026",
    title: "Research Intern @CMI (Chennai Mathematical Institute)",
    organization: "CMI",
    description: `
    Research Intern.
    `,
    logo: "https://www.cmi.ac.in/pix/cmi-header.png",
    logoClr: "bg-white",
    badges: [],
  },
  {
    date: "February 2026 - December 2026",
    title: "UG Research Fellow @TEXMiN (TTRP), IIT (ISM) Dhanbad",
    organization: "TEXMiN (TTRP)",
    description: `
    Building an AI/ML-powered Cyber-Physical System (CPS) for real-time hazard prediction in underground coal mines, funded by the National Mission on Interdisciplinary Cyber-Physical Systems.<br/>
    `,
    logo: "/images/texmin.png",
    logoClr: "bg-black",
    badges: [],
  },
  {
    date: "October 2025 - October 2026",
    title: "Web dev lead @CODEIIEST",
    organization: "CODEIIEST",
    description: `
    Currently volunteering as the web dev lead in CODEIIEST, the official coding club of IIEST Shibpur.
    Taking sessions, guiding juniors and keeping the interest growing as the main moto of this club.
    visit: <a href="https://www.codeiiest.in" target="_blank"><u>codeiiest</u></a>
    `,
    logo: "https://www.codeiiest.in/assets/logo/codeiiest-logo.png",
    logoClr: "bg-black",
    badges: [],
  },
  {
    date: "October 2024 - October 2025",
    title: "Google Developer Group IIESTS, Web Dev Core Member",
    organization: "GDG IIEST",
    description: `
    Active member of GDG on campus IIEST, participated in building multiple official and unofficial websites.
    <dl>
      <li>Student Sennet</li>
      <li>Kriti by Scage</li>
    </dl>
    `,
    logo: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjEuMTMgNTguNjEiPgoJPGRlZnM+CgkJPHN0eWxlPgoJCQkuY2xzLTEgewoJCQlmaWxsOiAjZmJiYzA0OwoJCQl9CgoJCQkuY2xzLTIgewoJCQlmaWxsOiAjNDI4NWY0OwoJCQl9CgoJCQkuY2xzLTMgewoJCQlmaWxsOiAjMzRhODUzOwoJCQl9CgoJCQkuY2xzLTQgewoJCQlmaWxsOiAjZWE0MzM1OwoJCQl9CgkJPC9zdHlsZT4KCTwvZGVmcz4KCTxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CgkJPGc+CgkJCTxwYXRoIGNsYXNzPSJjbHMtNCIKCQkJCWQ9Ik0yOC44NCwyOS40MmwxOS42Ny0xMS4zNmM0LjYzLTIuNjcsNi4yMS04LjU5LDMuNTQtMTMuMjJDNDkuMzgsLjIxLDQzLjQ2LTEuMzgsMzguODMsMS4zTDQuODQsMjAuOTJsMjQsOC41WiIgLz4KCQkJPHBhdGggY2xhc3M9ImNscy0yIgoJCQkJZD0iTTQzLjY2LDU4LjYxYzMuMzQsMCw2LjYtMS43NCw4LjM5LTQuODQsMi42Ny00LjYzLDEuMDktMTAuNTUtMy41NC0xMy4yMkwxNC41MiwyMC45M2MtNC42My0yLjY3LTEwLjU1LTEuMDktMTMuMjIsMy41NHMtMS4wOSwxMC41NSwzLjU0LDEzLjIybDMzLjk5LDE5LjYyYzEuNTMsLjg4LDMuMTksMS4zLDQuODMsMS4zWiIgLz4KCQkJPHBhdGggY2xhc3M9ImNscy0xIgoJCQkJZD0iTTc3LjQ3LDU4LjYxYzEuNjQsMCwzLjMxLS40Miw0LjgzLTEuM2wzMy45OS0xOS42Mi0yMy42OS04LjY3LTE5Ljk3LDExLjUzYy00LjYzLDIuNjctNi4yMSw4LjU5LTMuNTQsMTMuMjIsMS43OCwzLjEsNS4wNCw0Ljg0LDguMzgsNC44NFoiIC8+CgkJCTxwYXRoIGNsYXNzPSJjbHMtMyIKCQkJCWQ9Ik0xMTEuNDQsMzguOTljMy4zNCwwLDYuNi0xLjc0LDguMzktNC44NCwyLjY3LTQuNjMsMS4wOS0xMC41NS0zLjU0LTEzLjIyTDgyLjMsMS4zMWMtNC42My0yLjY3LTEwLjU1LTEuMDktMTMuMjIsMy41NC0yLjY3LDQuNjMtMS4wOSwxMC41NSwzLjU0LDEzLjIybDMzLjk5LDE5LjYyYzEuNTIsLjg4LDMuMTksMS4zLDQuODMsMS4zWiIgLz4KCQk8L2c+Cgk8L2c+Cjwvc3ZnPgo=",
    badges: [
      {
        type: "plain",
        text: "Student Sennet",
        icon: "",
        url: "https://students-senate-iiests.vercel.app",
      },
      { type: "plain", text: "Kriti", icon: "", url: "https://kriti.scage.in" },
    ],
  },

  {
    date: "October 2024",
    title: "Completed HactoberFest'24",
    organization: "HactoberFest'24",
    description:
      "Participated in Hactoberfest 2024, an OpenSource Contribution Event, and completed the event with 5 successful PR merges.",
    badges: [
      {
        type: "plain",
        text: "Badges",
        icon: "",
        url: `/images/hb.png`,
      },
    ],
    logoClr: "bg-sky-700",
    logo: "/images/hb.svg",
  },
];
